import { render, staticRenderFns } from "./service-company-settlement-drawer.vue?vue&type=template&id=497911aa&scoped=true"
import script from "./service-company-settlement-drawer.vue?vue&type=script&lang=js"
export * from "./service-company-settlement-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497911aa",
  null
  
)

export default component.exports